import { render, staticRenderFns } from "./InheritanceMore.vue?vue&type=template&id=0081de1c&scoped=true"
import script from "./InheritanceMore.vue?vue&type=script&lang=js"
export * from "./InheritanceMore.vue?vue&type=script&lang=js"
import style0 from "./InheritanceMore.vue?vue&type=style&index=0&id=0081de1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0081de1c",
  null
  
)

export default component.exports